const Load = {
  load: {
    key: process.env.VUE_APP_GMAP_KEY,
    libraries: process.env.VUE_APP_GMAP_LIBRARIES,
  },
};

export default Load;
